import type { PropsWithChildren } from "react";
import type { Props } from "./ClientPermissionsContext";
import { ClientPermissionsContext } from "./ClientPermissionsContext";

export const ClientPermissionsContextProvider = ({
  permissions,
  permissionSets,
  children,
}: PropsWithChildren<Props>) => (
  <ClientPermissionsContext
    value={{
      permissions,
      permissionSets,
      hasAnyPermission: (values: string[]) => {
        return permissions.some((p) => values.includes(p));
      },
      hasAnyPermissionForClient: (clientCode: string, values: string[]) => {
        const clientPermissions = permissionSets.find((p) => p.clientCode === clientCode);
        if (!clientPermissions) return false;
        return clientPermissions.permissions.some((p) => values.includes(p));
      },
    }}
  >
    {children}
  </ClientPermissionsContext>
);
